import { render, staticRenderFns } from "./listDetail.vue?vue&type=template&id=2fac11f0&scoped=true&"
import script from "./listDetail.vue?vue&type=script&lang=ts&"
export * from "./listDetail.vue?vue&type=script&lang=ts&"
import style0 from "./listDetail.vue?vue&type=style&index=0&id=2fac11f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac11f0",
  null
  
)

export default component.exports